import styled from 'styled-components'
import {Box, Typography} from '@mui/material'
import theme, {colors} from '../../styles/theme'

export const WorkshopBox = styled(Box)`
  width: 100%;
  max-width: 1220px;
  margin: 0 auto;
  box-sizing: border-box;
  padding: 32px 20px 64px;
  min-height: calc(100vh - 161px);

  ${theme.breakpoints.down('md')} {
    min-height: calc(100vh - 121px);
  }

  ${theme.breakpoints.down('sm')} {
    padding: 20px 20px 64px;
  }
`

export const Title = styled(Typography)`
  font-size: 48px !important;
  color: ${colors.bksBlack} !important;

  ${theme.breakpoints.down('sm')} {
    font-size: 32px !important;
  }
`

export const Subtitle = styled(Typography)`
  font-size: 24px !important;
  color: ${colors.bksGray80} !important;
  font-weight: 700 !important;
`

export const LightText = styled(Typography)`
  color: ${colors.bksGray60} !important;

  && span {
    color: ${colors.blue1} !important;
  }
`

export const DivisionsBox = styled(Box)`
  margin-top: 48px;
  display: flex;
  flex-wrap: wrap;
  gap: 24px;

  ${theme.breakpoints.down('sm')} {
    flex-flow: column;
    margin-top: 32px;
  }
`

export const DivisionItem = styled(Box)<{$isActive?: boolean}>`
  flex: 1 1 calc(50% - 24px);
  display: flex;
  align-items: center;
  gap: 16px;
  cursor: pointer;

  ${({$isActive}) =>
    $isActive ? `color: ${colors.bksGray50};` : `color: ${colors.bksBlack};`}

  &:hover {
    color: ${colors.bksGray50};
  }
`

export const Divider = styled.div`
  background-color: #c4c4c4;
  height: 1px;
  width: 100%;
  margin: 48px 0;
`

export const VwFlexBox = styled(Box)`
  display: flex;
  gap: 32px;

  ${theme.breakpoints.down('sm')} {
    flex-flow: column;
  }
`

export const VwLeftBox = styled(Box)`
  width: 100%;
`

export const VwRightBox = styled(Box)`
  min-width: 190px;
  max-width: 190px;

  display: flex;
  flex-flow: column;
  gap: 16px;

  && a {
    width: 190px !important;
  }

  && button {
    width: 190px !important;
  }

  ${theme.breakpoints.down('sm')} {
    min-width: 100%;
    max-width: 100%;

    && a {
      width: 100% !important;
    }

    && button {
      width: 100% !important;
    }
  }
`

export const CalendarAlertBox = styled(Box)`
  background: ${colors.crimsonRed};
  color: #fff;
  font-weight: 700;
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 4px;
  height: 23px;
  padding: 0 8px;
  width: fit-content !important;
  margin-top: 8px;

  && img {
    height:;
  }
`
